import React from 'react';
import { TypedMemo } from '../../common/types';
import { AccountStatsViewRendererProps } from './props';
import { SMLStatCards } from '../stats/SMLStatCards';
import { SMLStatCardsSkeleton } from '../stats/SMLStatCardsSkeleton';

/**
 * The four headline numbers across the top of the Smartlinks index.
 *
 * Only the cards: the chart and the breakdowns belong to a single SmartLink,
 * and the design keeps them on the detail page.
 */
const AccountStatsViewRendererComponent: React.FC<AccountStatsViewRendererProps> = ({ stats, isLoading }) => {
  if (isLoading || !stats) {
    return <SMLStatCardsSkeleton />;
  }
  return <SMLStatCards totals={stats.stats.totals} />;
};

export const AccountStatsViewRenderer = TypedMemo(AccountStatsViewRendererComponent);
